var _circle, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3, _g4, _path7, _g5, _path8, _g6, _ellipse, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g7, _g8, _path23, _g9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileParsingIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 674,
    viewBox: "0 0 960 674",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "exclusion"
    },
    filter: "url(#filter0_f_1197_17576)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 481,
    cy: 134,
    r: 140,
    fill: "#E66F44",
    fillOpacity: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1197_17576)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 481,
    cy: 166.5,
    rx: 113,
    ry: 67.5,
    fill: "#E66F44",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1197_17576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481 286C532.497 286 579.701 273.559 614.432 252.816C648.916 232.222 673 202.084 673 166.5C673 130.916 648.916 100.778 614.432 80.1835C579.701 59.4411 532.497 47 481 47C429.503 47 382.299 59.4411 347.568 80.1835C313.084 100.778 289 130.916 289 166.5C289 202.084 313.084 232.222 347.568 252.816C382.299 273.559 429.503 286 481 286Z",
    stroke: "#4472E6",
    strokeOpacity: 0.5,
    strokeWidth: 24
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482 314L440.5 296L482 281.5L521 296L482 314Z",
    fill: "#110B18",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 325V318.5L466 331L440.5 325Z",
    fill: "#110B18",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M482 315L472 330L482 323V315Z",
    fill: "#110B18",
    fillOpacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M482.5 314.5L490.5 325L482.5 323V314.5Z",
    fill: "#110B18",
    fillOpacity: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M430.084 309.553L440.353 296.431L481.261 281.84C481.877 281.621 482.551 281.628 483.162 281.861L521.333 296.431L531.095 309.638C532.096 310.993 531.652 312.921 530.16 313.702L522.02 317.963V339.343C522.02 340.383 521.432 341.333 520.502 341.798L482.216 360.941L441.919 341.784C440.963 341.329 440.353 340.364 440.353 339.305V318.291L431.034 313.708C429.47 312.939 429.01 310.926 430.084 309.553Z",
    fill: "#241536",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.353 296.431L430.084 309.553C429.01 310.926 429.47 312.939 431.034 313.708L440.353 318.291M440.353 296.431L482.216 314.275M440.353 296.431L481.261 281.84C481.877 281.621 482.551 281.628 483.162 281.861L521.333 296.431M482.216 314.275L471.198 330.801C470.434 331.947 468.939 332.35 467.703 331.742L440.353 318.291M482.216 314.275L521.333 296.431M482.216 314.275L494.868 329.704C495.693 330.71 497.111 330.999 498.263 330.396L530.16 313.702C531.652 312.921 532.096 310.993 531.095 309.638L521.333 296.431M482.216 314.275V360.941M482.216 360.941L520.502 341.798C521.432 341.333 522.02 340.383 522.02 339.343V317.963M482.216 360.941L441.919 341.784C440.963 341.329 440.353 340.364 440.353 339.305V318.291",
    stroke: "#37244F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1197_17576)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1197_17576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.325 265.862C476.045 265.556 477.221 265.536 477.952 265.816L513.761 279.562C514.492 279.843 514.5 280.318 513.78 280.624L468.344 299.91C467.624 300.216 466.447 300.236 465.717 299.956L429.907 286.21C429.177 285.929 429.168 285.454 429.889 285.148L475.325 265.862Z",
    fill: "#68376F",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.325 265.862C476.045 265.556 477.221 265.536 477.952 265.816L513.761 279.562C514.492 279.843 514.5 280.318 513.78 280.624L468.344 299.91C467.624 300.216 466.447 300.236 465.717 299.956L429.907 286.21C429.177 285.929 429.168 285.454 429.889 285.148L475.325 265.862Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.0988,
    height: 3.09161,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 477.078 266.971)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.4576,
    height: 16.1855,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 472.48 268.925)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.63718,
    height: 3.63718,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 485.145 275.006)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.63718,
    height: 3.63718,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 480.461 276.996)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.63718,
    height: 3.63718,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 475.769 278.986)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.7297,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 489.234 277.252)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.5535,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 455.816 275.996)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.2782,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 453.059 277.167)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.7344,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 450.297 278.341)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.643,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 447.531 279.512)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.2802,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 444.773 280.684)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.643,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 442.007 281.859)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.00113,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 485.215 278.957)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.00113,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 479.188 281.516)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.91133,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 483.203 279.811)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.1848,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 481.195 280.663)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6397,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 487.227 278.105)",
    fill: "#6C447F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M475.325 265.862C476.045 265.556 477.221 265.536 477.952 265.816L513.761 279.562C514.492 279.843 514.5 280.318 513.78 280.624L468.344 299.91C467.624 300.216 466.447 300.236 465.717 299.956L429.907 286.21C429.177 285.929 429.168 285.454 429.889 285.148L475.325 265.862Z",
    stroke: "#5E376F",
    strokeWidth: 0.516131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1197_17576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.739 257.554C477.459 257.248 478.635 257.227 479.366 257.508L515.175 271.254C515.906 271.534 515.914 272.009 515.194 272.315L469.758 291.602C469.038 291.907 467.862 291.928 467.131 291.647L431.321 277.901C430.591 277.621 430.582 277.146 431.303 276.84L476.739 257.554Z",
    fill: "#68376F",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.0988,
    height: 3.09161,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 478.492 258.663)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.4576,
    height: 16.1855,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 473.895 260.616)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.63718,
    height: 3.63718,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 486.559 266.698)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.63718,
    height: 3.63718,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 481.875 268.688)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.63718,
    height: 3.63718,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 477.183 270.677)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.7297,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 490.648 268.944)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.5535,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 457.23 267.688)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.2782,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 454.473 268.859)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.7344,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 451.711 270.032)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.643,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 448.945 271.204)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.2802,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 446.188 272.376)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.643,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 443.421 273.55)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.00113,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 486.629 270.649)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.00113,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 480.602 273.208)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.91133,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 484.617 271.502)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.1848,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 482.609 272.354)",
    fill: "#6C447F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6397,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 488.641 269.797)",
    fill: "#6C447F"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M476.739 257.554C477.459 257.248 478.635 257.227 479.366 257.508L515.175 271.254C515.906 271.534 515.914 272.009 515.194 272.315L469.758 291.602C469.038 291.907 467.862 291.928 467.131 291.647L431.321 277.901C430.591 277.621 430.582 277.146 431.303 276.84L476.739 257.554Z",
    stroke: "#5E376F",
    strokeWidth: 0.516131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1197_17576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.739 247.554C487.459 247.248 488.635 247.227 489.366 247.508L525.175 261.254C525.906 261.534 525.914 262.009 525.194 262.315L479.758 281.602C479.038 281.907 477.862 281.928 477.131 281.647L441.321 267.901C440.591 267.621 440.582 267.146 441.303 266.84L486.739 247.554Z",
    fill: "#68376F",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.0988,
    height: 3.09161,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 488.492 248.663)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.4576,
    height: 16.1855,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 483.895 250.616)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.63718,
    height: 3.63718,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 496.559 256.698)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.63718,
    height: 3.63718,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 491.875 258.688)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.63718,
    height: 3.63718,
    rx: 0.727437,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 487.183 260.677)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.7297,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 500.648 258.944)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.5535,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 467.23 257.688)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.2782,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 464.473 258.859)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.7344,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 461.711 260.032)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.643,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 458.945 261.204)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.2802,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 456.188 262.376)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.643,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 453.421 263.55)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.00113,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 496.629 260.649)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.00113,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 490.602 263.208)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.91133,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 494.617 261.502)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.1848,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 492.609 262.354)",
    fill: "#A57CB8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.6397,
    height: 1.09116,
    rx: 0.545578,
    transform: "matrix(0.93358 0.358368 -0.920505 0.390731 498.641 259.797)",
    fill: "#A57CB8"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M486.739 247.554C487.459 247.248 488.635 247.227 489.366 247.508L525.175 261.254C525.906 261.534 525.914 262.009 525.194 262.315L479.758 281.602C479.038 281.907 477.862 281.928 477.131 281.647L441.321 267.901C440.591 267.621 440.582 267.146 441.303 266.84L486.739 247.554Z",
    stroke: "#A57CB8",
    strokeWidth: 0.516131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1197_17576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.478 237.664C497.342 237.297 498.753 237.273 499.63 237.609L534.911 251.152C535.788 251.489 535.798 252.059 534.933 252.426L490.018 271.491C489.154 271.858 487.743 271.882 486.867 271.546L451.585 258.003C450.709 257.666 450.699 257.096 451.563 256.729L496.478 237.664Z",
    fill: "#F6F7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.71 238.995C498.142 238.812 498.847 238.799 499.286 238.968L530.466 250.937C530.905 251.105 530.909 251.39 530.477 251.573L529.196 252.117C528.764 252.301 528.059 252.313 527.62 252.145L496.44 240.176C496.002 240.007 495.997 239.722 496.429 239.539L497.71 238.995Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.112 240.948C493.544 240.765 494.25 240.753 494.688 240.921L505.665 245.134C506.103 245.303 506.108 245.588 505.676 245.771L492.342 251.431C491.91 251.614 491.204 251.627 490.766 251.459L479.789 247.245C479.351 247.077 479.346 246.792 479.778 246.608L493.112 240.948Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.776 247.03C506.208 246.846 506.914 246.834 507.352 247.002L509.161 247.696C509.599 247.865 509.604 248.15 509.172 248.333L507.389 249.09C506.956 249.273 506.251 249.286 505.813 249.118L504.004 248.423C503.566 248.255 503.561 247.97 503.993 247.787L505.776 247.03Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.093 249.02C501.525 248.836 502.23 248.824 502.668 248.992L504.477 249.686C504.915 249.855 504.92 250.14 504.488 250.323L502.705 251.08C502.273 251.263 501.567 251.276 501.129 251.108L499.32 250.413C498.882 250.245 498.877 249.96 499.309 249.777L501.093 249.02Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.401 251.009C496.833 250.826 497.538 250.814 497.977 250.982L499.785 251.676C500.223 251.844 500.228 252.129 499.796 252.313L498.013 253.07C497.581 253.253 496.875 253.265 496.437 253.097L494.629 252.403C494.19 252.235 494.185 251.95 494.617 251.766L496.401 251.009Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.146 249.157C510.424 249.039 510.876 249.031 511.158 249.139L520.156 252.593C520.437 252.701 520.441 252.884 520.163 253.002C519.886 253.12 519.433 253.128 519.152 253.02L510.153 249.565C509.872 249.457 509.869 249.275 510.146 249.157Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.728 247.901C477.006 247.783 477.459 247.775 477.74 247.883L509.913 260.233C510.194 260.341 510.198 260.524 509.92 260.642C509.643 260.76 509.19 260.768 508.909 260.66L476.735 248.309C476.454 248.201 476.451 248.018 476.728 247.901Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.97 249.072C474.248 248.955 474.701 248.947 474.982 249.055L496.629 257.364C496.91 257.472 496.913 257.655 496.636 257.773C496.359 257.891 495.906 257.898 495.625 257.79L473.978 249.481C473.696 249.373 473.693 249.19 473.97 249.072Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.209 250.245C471.486 250.128 471.939 250.12 472.22 250.228L500.828 261.209C501.11 261.317 501.113 261.5 500.835 261.618C500.558 261.736 500.105 261.744 499.824 261.636L471.216 250.654C470.935 250.546 470.931 250.363 471.209 250.245Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.443 251.417C468.72 251.299 469.173 251.291 469.455 251.399L496.11 261.631C496.391 261.739 496.395 261.922 496.117 262.04C495.84 262.158 495.387 262.166 495.106 262.058L468.45 251.826C468.169 251.718 468.166 251.535 468.443 251.417Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.685 252.589C465.963 252.471 466.416 252.463 466.697 252.571L496.748 264.107C497.029 264.215 497.032 264.398 496.755 264.515C496.478 264.633 496.025 264.641 495.744 264.533L465.692 252.998C465.411 252.89 465.408 252.707 465.685 252.589Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.919 253.763C463.197 253.646 463.649 253.638 463.931 253.746L490.586 263.978C490.868 264.086 490.871 264.269 490.593 264.387C490.316 264.504 489.863 264.512 489.582 264.404L462.926 254.172C462.645 254.064 462.642 253.881 462.919 253.763Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.127 250.862C506.404 250.744 506.857 250.736 507.138 250.844L510.789 252.246C511.07 252.354 511.073 252.537 510.796 252.654C510.518 252.772 510.065 252.78 509.784 252.672L506.134 251.271C505.853 251.163 505.849 250.98 506.127 250.862Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.099 253.421C500.377 253.303 500.83 253.296 501.111 253.404L504.761 254.805C505.042 254.913 505.046 255.096 504.768 255.213C504.491 255.331 504.038 255.339 503.757 255.231L500.106 253.83C499.825 253.722 499.822 253.539 500.099 253.421Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.115 251.716C504.392 251.598 504.845 251.59 505.127 251.698L513.361 254.859C513.642 254.967 513.645 255.15 513.368 255.268C513.091 255.385 512.638 255.393 512.356 255.285L504.122 252.124C503.841 252.016 503.838 251.833 504.115 251.716Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.107 252.568C502.385 252.45 502.837 252.442 503.119 252.55L514.409 256.884C514.69 256.992 514.694 257.175 514.416 257.293C514.139 257.41 513.686 257.418 513.405 257.31L502.114 252.976C501.833 252.868 501.83 252.685 502.107 252.568Z",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.138 250.01C508.416 249.892 508.869 249.884 509.15 249.992L521.799 254.848C522.08 254.956 522.083 255.139 521.806 255.256C521.528 255.374 521.075 255.382 520.794 255.274L508.146 250.419C507.864 250.311 507.861 250.128 508.138 250.01Z",
    fill: "#D9CDFF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 483,
    cy: 371.5,
    rx: 47,
    ry: 4.5,
    fill: "#1A0926"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M248.598 221.844C247.649 223.63 245.118 227.715 242.59 229.768C239.431 232.335 240.482 235.441 241.688 237.53L244.903 243.1C244.839 242.023 245.52 239.216 248.763 236.601C251.123 235.115 255.587 230.991 254.561 226.384C253.536 221.778 250.335 216.385 248.863 214.264C250.458 217.799 249.351 220.79 248.598 221.844Z",
    fill: "#503F65",
    fillOpacity: 0.3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M218.606 204.626C220.579 208.686 227.106 217.097 237.434 218.264C241.059 218.646 248.366 219.898 248.598 221.844C249.351 220.79 250.458 217.799 248.863 214.264C247.642 213.113 243.566 210.49 237.034 209.211C228.87 207.612 221.75 202.811 217.525 199.124C217.614 200.962 217.95 202.811 218.606 204.626Z",
    fill: "#503F65",
    fillOpacity: 0.7
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M224.048 180.033C224.737 179.096 224.862 177.837 224.28 176.829L221.149 171.405C220.253 169.854 218.155 169.59 217.124 171.055C214.194 175.22 211.049 182.397 212.702 190.769C213.761 194.242 216.425 201.876 218.606 204.626C217.95 202.811 217.614 200.962 217.525 199.124C217.162 191.558 221.003 184.176 224.048 180.033Z",
    fill: "#503F65",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.606 204.626C220.579 208.686 227.106 217.097 237.434 218.264C241.059 218.646 248.366 219.898 248.598 221.844M218.606 204.626C217.95 202.811 217.614 200.962 217.525 199.124M218.606 204.626C216.425 201.876 213.761 194.242 212.702 190.769C211.049 182.397 214.194 175.22 217.124 171.055C218.155 169.59 220.253 169.854 221.149 171.405L224.28 176.829C224.862 177.837 224.737 179.096 224.048 180.033C221.003 184.176 217.162 191.558 217.525 199.124M248.598 221.844C247.649 223.63 245.118 227.715 242.59 229.768C239.431 232.335 240.482 235.441 241.688 237.53M248.598 221.844C249.351 220.79 250.458 217.799 248.863 214.264M241.688 237.53C242.652 239.201 244.233 241.94 244.903 243.1M241.688 237.53L244.903 243.1M244.903 243.1C244.839 242.023 245.52 239.216 248.763 236.601C251.123 235.115 255.587 230.991 254.561 226.384C253.536 221.778 250.335 216.385 248.863 214.264M248.863 214.264C247.642 213.113 243.566 210.49 237.034 209.211C228.87 207.612 221.75 202.811 217.525 199.124",
    stroke: "#503F65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M728.348 247.968C728.936 249.074 730.504 251.604 732.069 252.876C734.026 254.466 733.375 256.39 732.628 257.683L730.637 261.133C730.677 260.466 730.255 258.728 728.246 257.108C726.784 256.187 724.02 253.633 724.655 250.78C725.29 247.927 727.272 244.587 728.184 243.273C727.196 245.463 727.882 247.315 728.348 247.968Z",
    fill: "#503F65",
    fillOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M746.924 237.304C745.702 239.818 741.66 245.028 735.263 245.75C733.018 245.987 728.492 246.763 728.348 247.968C727.882 247.315 727.196 245.463 728.184 243.273C728.941 242.56 731.465 240.936 735.51 240.144C740.567 239.153 744.977 236.18 747.594 233.896C747.539 235.034 747.33 236.179 746.924 237.304Z",
    fill: "#503F65",
    fillOpacity: 0.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M743.554 222.072C743.127 221.491 743.05 220.712 743.41 220.087L745.349 216.728C745.904 215.768 747.204 215.604 747.842 216.511C749.657 219.091 751.604 223.536 750.581 228.721C749.925 230.872 748.275 235.6 746.924 237.304C747.33 236.179 747.539 235.034 747.594 233.896C747.819 229.21 745.439 224.638 743.554 222.072Z",
    fill: "#503F65",
    fillOpacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M746.924 237.304C745.702 239.818 741.66 245.028 735.263 245.75C733.018 245.987 728.492 246.763 728.348 247.968M746.924 237.304C747.33 236.179 747.539 235.034 747.594 233.896M746.924 237.304C748.275 235.6 749.925 230.872 750.581 228.721C751.604 223.536 749.657 219.091 747.842 216.511C747.204 215.604 745.904 215.768 745.349 216.728L743.41 220.087C743.05 220.712 743.127 221.491 743.554 222.072C745.439 224.638 747.819 229.21 747.594 233.896M728.348 247.968C728.936 249.074 730.504 251.604 732.069 252.876C734.026 254.466 733.375 256.39 732.628 257.683M728.348 247.968C727.882 247.315 727.196 245.463 728.184 243.273M732.628 257.683C732.031 258.718 731.052 260.414 730.637 261.133M732.628 257.683L730.637 261.133M730.637 261.133C730.677 260.466 730.255 258.728 728.246 257.108C726.784 256.187 724.02 253.633 724.655 250.78C725.29 247.927 727.272 244.587 728.184 243.273M728.184 243.273C728.941 242.56 731.465 240.936 735.51 240.144C740.567 239.153 744.977 236.18 747.594 233.896",
    stroke: "#503F65",
    strokeWidth: 0.619357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M595.605 213.263C595.115 214.185 593.809 216.293 592.504 217.353C590.873 218.678 591.416 220.281 592.038 221.359L593.698 224.234C593.665 223.678 594.016 222.23 595.69 220.88C596.908 220.113 599.212 217.984 598.683 215.607C598.153 213.229 596.502 210.445 595.742 209.351C596.565 211.175 595.994 212.719 595.605 213.263Z",
    fill: "#503F65",
    fillOpacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M580.125 204.377C581.143 206.472 584.512 210.813 589.843 211.415C591.714 211.613 595.485 212.259 595.605 213.263C595.994 212.719 596.565 211.175 595.742 209.351C595.111 208.757 593.007 207.403 589.636 206.743C585.423 205.918 581.748 203.44 579.567 201.537C579.613 202.485 579.786 203.439 580.125 204.377Z",
    fill: "#503F65",
    fillOpacity: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M582.934 191.683C583.29 191.199 583.354 190.55 583.054 190.029L581.437 187.23C580.975 186.43 579.892 186.293 579.36 187.049C577.848 189.199 576.225 192.903 577.078 197.224C577.624 199.017 578.999 202.957 580.125 204.377C579.786 203.439 579.613 202.485 579.567 201.537C579.38 197.632 581.362 193.821 582.934 191.683Z",
    fill: "#503F65",
    fillOpacity: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M580.125 204.377C581.143 206.472 584.512 210.813 589.843 211.415C591.714 211.613 595.485 212.259 595.605 213.263M580.125 204.377C579.786 203.439 579.613 202.485 579.567 201.537M580.125 204.377C578.999 202.957 577.624 199.017 577.078 197.224C576.225 192.903 577.848 189.199 579.36 187.049C579.892 186.293 580.975 186.43 581.437 187.23L583.054 190.029C583.354 190.55 583.29 191.199 582.934 191.683C581.362 193.821 579.38 197.632 579.567 201.537M595.605 213.263C595.115 214.185 593.809 216.293 592.504 217.353C590.873 218.678 591.416 220.281 592.038 221.359M595.605 213.263C595.994 212.719 596.565 211.175 595.742 209.351M592.038 221.359C592.536 222.222 593.352 223.635 593.698 224.234M592.038 221.359L593.698 224.234M593.698 224.234C593.665 223.678 594.016 222.23 595.69 220.88C596.908 220.113 599.212 217.984 598.683 215.607C598.153 213.229 596.502 210.445 595.742 209.351M595.742 209.351C595.111 208.757 593.007 207.403 589.636 206.743C585.423 205.918 581.748 203.44 579.567 201.537",
    stroke: "#503F65",
    strokeWidth: 0.516131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M372.899 284.645C373.291 285.383 374.336 287.069 375.38 287.917C376.684 288.977 376.25 290.26 375.752 291.122L374.424 293.422C374.451 292.977 374.17 291.818 372.831 290.739C371.856 290.125 370.013 288.422 370.437 286.52C370.86 284.618 372.182 282.391 372.789 281.515C372.131 282.975 372.588 284.21 372.899 284.645Z",
    fill: "#503F65",
    fillOpacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M385.283 277.536C384.468 279.212 381.773 282.685 377.509 283.167C376.012 283.325 372.995 283.842 372.899 284.645C372.588 284.21 372.131 282.975 372.789 281.515C373.294 281.04 374.977 279.957 377.674 279.429C381.045 278.769 383.985 276.787 385.729 275.264C385.693 276.023 385.554 276.786 385.283 277.536Z",
    fill: "#503F65",
    fillOpacity: 0.7
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M383.036 267.382C382.751 266.994 382.7 266.474 382.94 266.058L384.233 263.819C384.603 263.178 385.469 263.069 385.895 263.674C387.105 265.394 388.403 268.357 387.721 271.814C387.283 273.248 386.183 276.4 385.283 277.536C385.554 276.786 385.693 276.023 385.729 275.264C385.879 272.14 384.293 269.092 383.036 267.382Z",
    fill: "#503F65",
    fillOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M385.283 277.536C384.468 279.212 381.773 282.685 377.509 283.167C376.012 283.325 372.995 283.842 372.899 284.645M385.283 277.536C385.554 276.786 385.693 276.023 385.729 275.264M385.283 277.536C386.183 276.4 387.283 273.248 387.721 271.814C388.403 268.357 387.105 265.394 385.895 263.674C385.469 263.069 384.603 263.178 384.233 263.819L382.94 266.058C382.7 266.474 382.751 266.994 383.036 267.382C384.293 269.092 385.879 272.14 385.729 275.264M372.899 284.645C373.291 285.383 374.336 287.069 375.38 287.917C376.684 288.977 376.25 290.26 375.752 291.122M372.899 284.645C372.588 284.21 372.131 282.975 372.789 281.515M375.752 291.122C375.354 291.812 374.701 292.943 374.424 293.422M375.752 291.122L374.424 293.422M374.424 293.422C374.451 292.977 374.17 291.818 372.831 290.739C371.856 290.125 370.013 288.422 370.437 286.52C370.86 284.618 372.182 282.391 372.789 281.515M372.789 281.515C373.294 281.04 374.977 279.957 377.674 279.429C381.045 278.769 383.985 276.787 385.729 275.264",
    stroke: "#503F65",
    strokeWidth: 0.412905,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1197_17576)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1197_17576)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.086,
    y: 147.031,
    width: 48.1269,
    height: 60.9819,
    rx: 1.17307,
    transform: "rotate(-45 442.086 147.031)",
    fill: "#6F374C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.77,
    y: 146.655,
    width: 41.0088,
    height: 3.61217,
    rx: 0.849922,
    transform: "rotate(-45 445.77 146.655)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.898,
    y: 150.787,
    width: 15.7236,
    height: 18.9108,
    rx: 0.849922,
    transform: "rotate(-45 449.898 150.787)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.797,
    y: 139.594,
    width: 4.24961,
    height: 4.24961,
    rx: 0.849923,
    transform: "rotate(-45 463.797 139.594)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.004,
    y: 143.8,
    width: 4.24961,
    height: 4.24961,
    rx: 0.849923,
    transform: "rotate(-45 468.004 143.8)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.211,
    y: 148.007,
    width: 4.24961,
    height: 4.24961,
    rx: 0.849923,
    transform: "rotate(-45 472.211 148.007)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.906,
    y: 135.988,
    width: 12.5364,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 468.906 135.988)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.852,
    y: 165.736,
    width: 41.54,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 464.852 165.736)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.328,
    y: 168.215,
    width: 28.3662,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 467.328 168.215)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.809,
    y: 170.695,
    width: 37.0779,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 469.809 170.695)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.285,
    y: 173.174,
    width: 34.6343,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 472.285 173.174)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.762,
    y: 175.652,
    width: 38.884,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 474.762 175.652)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.247,
    y: 178.132,
    width: 34.6343,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 477.247 178.132)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.512,
    y: 139.594,
    width: 5.84322,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 472.512 139.594)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.922,
    y: 145.002,
    width: 5.84322,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 477.922 145.002)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.316,
    y: 141.396,
    width: 11.5802,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 474.316 141.396)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.117,
    y: 143.199,
    width: 15.4048,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 476.117 143.199)",
    fill: "#7F445A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.711,
    y: 137.79,
    width: 17.1047,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 470.711 137.79)",
    fill: "#7F445A"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 442.086,
    y: 147.031,
    width: 48.1269,
    height: 60.9819,
    rx: 1.17307,
    transform: "rotate(-45 442.086 147.031)",
    stroke: "#6F374C",
    strokeWidth: 0.427334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1197_17576)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_1197_17576)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.086,
    y: 147.031,
    width: 48.1269,
    height: 60.9819,
    rx: 1.69984,
    transform: "rotate(-45 442.086 147.031)",
    fill: "#F6F7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.898,
    y: 150.787,
    width: 15.7236,
    height: 18.9108,
    rx: 0.849922,
    transform: "rotate(-45 449.898 150.787)",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.852,
    y: 165.737,
    width: 41.54,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 464.852 165.737)",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.328,
    y: 168.216,
    width: 28.3662,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 467.328 168.216)",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.809,
    y: 170.695,
    width: 37.0779,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 469.809 170.695)",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.285,
    y: 173.174,
    width: 34.6343,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 472.285 173.174)",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.762,
    y: 175.653,
    width: 38.884,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 474.762 175.653)",
    fill: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.247,
    y: 178.132,
    width: 34.6343,
    height: 1.27488,
    rx: 0.637442,
    transform: "rotate(-45 477.247 178.132)",
    fill: "#D9CDFF"
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M413.278 160.502C413.404 159.362 414.367 158.5 415.514 158.5H543.986C545.327 158.5 546.37 159.666 546.222 160.998C546.096 162.138 545.133 163 543.986 163H415.514C414.173 163 413.13 161.834 413.278 160.502Z",
    fill: "#DD7841"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1197_17576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.278 160.502C413.404 159.362 414.367 158.5 415.514 158.5H543.986C545.327 158.5 546.37 159.666 546.222 160.998C546.096 162.138 545.133 163 543.986 163H415.514C414.173 163 413.13 161.834 413.278 160.502Z",
    fill: "white",
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M413.278 160.502C413.404 159.362 414.367 158.5 415.514 158.5H543.986C545.327 158.5 546.37 159.666 546.222 160.998C546.096 162.138 545.133 163 543.986 163H415.514C414.173 163 413.13 161.834 413.278 160.502Z",
    fill: "#F48549",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1197_17576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.278 160.502C413.404 159.362 414.367 158.5 415.514 158.5H543.986C545.327 158.5 546.37 159.666 546.222 160.998C546.096 162.138 545.133 163 543.986 163H415.514C414.173 163 413.13 161.834 413.278 160.502Z",
    fill: "#FFA170",
    style: {
      mixBlendMode: "hard-light"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1197_17576",
    x: -59,
    y: -406,
    width: 1080,
    height: 1080,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_1197_17576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1197_17576",
    x: 218,
    y: -51,
    width: 526,
    height: 435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_1197_17576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1197_17576",
    x: 127,
    y: -115,
    width: 708,
    height: 563,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_1197_17576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1197_17576",
    x: 424.584,
    y: 261.308,
    width: 94.4995,
    height: 43.1553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1197_17576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1197_17576",
    x: 409.264,
    y: 154.5,
    width: 140.973,
    height: 12.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1197_17576"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1197_17576",
    x: 389.264,
    y: 134.5,
    width: 180.973,
    height: 52.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1197_17576"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_17576"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.325 265.862C476.045 265.556 477.221 265.536 477.952 265.816L513.761 279.562C514.492 279.843 514.5 280.318 513.78 280.624L468.344 299.91C467.624 300.216 466.447 300.236 465.717 299.956L429.907 286.21C429.177 285.929 429.168 285.454 429.889 285.148L475.325 265.862Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1197_17576"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.739 257.554C477.459 257.248 478.635 257.227 479.366 257.508L515.175 271.254C515.906 271.534 515.914 272.009 515.194 272.315L469.758 291.602C469.038 291.907 467.862 291.928 467.131 291.647L431.321 277.901C430.591 277.621 430.582 277.146 431.303 276.84L476.739 257.554Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1197_17576"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.739 247.554C487.459 247.248 488.635 247.227 489.366 247.508L525.175 261.254C525.906 261.534 525.914 262.009 525.194 262.315L479.758 281.602C479.038 281.907 477.862 281.928 477.131 281.647L441.321 267.901C440.591 267.621 440.582 267.146 441.303 266.84L486.739 247.554Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1197_17576"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.478 237.664C497.342 237.297 498.753 237.273 499.63 237.609L534.911 251.152C535.788 251.489 535.798 252.059 534.933 252.426L490.018 271.491C489.154 271.858 487.743 271.882 486.867 271.546L451.585 258.003C450.709 257.666 450.699 257.096 451.563 256.729L496.478 237.664Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1197_17576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 46.3656,
    fill: "white",
    transform: "translate(442 113)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1197_17576"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.086,
    y: 147.031,
    width: 48.1269,
    height: 60.9819,
    rx: 1.17307,
    transform: "rotate(-45 442.086 147.031)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1197_17576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 30.6344,
    fill: "white",
    transform: "translate(442 159.366)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_1197_17576"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.086,
    y: 147.031,
    width: 48.1269,
    height: 60.9819,
    rx: 1.69984,
    transform: "rotate(-45 442.086 147.031)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileParsingIllustration);
export default __webpack_public_path__ + "static/media/file-parsing-illustration.2614cc9c2f400214c0ecb1fc97920078.svg";
export { ForwardRef as ReactComponent };